<template>
  <div class="item comment-item">
    <div class="item-point"></div>
    <div class="item-date">
      <span>{{timeDifference(comment.created_at)}}</span>
      <span v-if="outgoing" class="icon sli-cloud-upload"></span>
      <span v-else class="icon sli-cloud-download"></span>
    </div>
    <div class="item-content" :class="{'outgoing-comment': outgoing}">
      <div class="comment-text">
        <smiley-text v-if="comment.type === 'text'" :content="comment.text" />
        <div v-else-if="comment.type === 'md'" v-html="markdown"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { marked } from 'marked'

export default {
  components: {
  },
  props: {
    comment: Object,
    outgoing: Boolean
  },
  computed: {
    markdown () {
      if (this.comment.type && this.comment.type === 'md') {
        return marked(this.comment.text)
      }
      return ''
    }
  },
  methods: {
    humanReadable (current, previous) {
      var msPerMinute = 60 * 1000
      var msPerHour = msPerMinute * 60
      var msPerDay = msPerHour * 24
      var msPerMonth = msPerDay * 30
      var msPerYear = msPerDay * 365
      var elapsed = current - previous
      if (elapsed < msPerMinute) {
        return Math.round(elapsed / 1000) + ' ' + this.$t('comment.seconds_ago')
      } else if (elapsed < msPerHour) {
        return Math.round(elapsed / msPerMinute) + ' ' + this.$t('comment.minutes_ago')
      } else if (elapsed < msPerDay) {
        return Math.round(elapsed / msPerHour) + ' ' + this.$t('comment.hours_ago')
      } else if (elapsed < msPerMonth) {
        return Math.round(elapsed / msPerDay) + ' ' + this.$t('comment.days_ago')
      } else if (elapsed < msPerYear) {
        return Math.round(elapsed / msPerMonth) + ' ' + this.$t('comment.months_ago')
      } else {
        return Math.round(elapsed / msPerYear) + ' ' + this.$t('comment.years_ago')
      }
    },
    timeDifference (timestamp) {
      var created = new Date(timestamp * 1000)
      return this.humanReadable(new Date(), created)
    }
  }
}
</script>

<style>
.comment{
  text-align: right;
}
.comment-item {
  max-width: 95%;
}
.comment-item .item-date {
  direction: rtl;
  font-size: smaller;
}
.comment-item .item-date .icon {
  font-size: small !important;
  margin: 0 5px;
}
.comment-item .item-content {
    background-color: var(--incomming-message-bg-color) !important;
    border-radius: 3px !important;
}
.comment-text {
  font-size: 1em;
  color: var(--incomming-message-color);
}
.comment-item .item-content.outgoing-comment {
    background-color: var(--outgoing-message-bg-color) !important;
}
.outgoing-comment .comment-text {
  color: var(--outgoing-message-color);
}
.comment-item .item-content table {
  border-collapse: separate;
  border-spacing: 2px 2px;
}
.comment-item .item-content table td, th {
  border: 1px dotted #ddd;
  padding: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/Comment.vue